export const getAllClans = async (token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/clan`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const clansData = data.clans;
            return clansData;
        } else {
            throw new Error('Failed to fetch user data');
        }
    } catch (error) {
        console.error('Error:', error);
    }
};